var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-container" }, [
    _c("div", { staticClass: "prompt-heading" }, [
      _c("div", [_vm._v(_vm._s(_vm._f("trans")("Selected")))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "prompt-container" },
        [
          this.creatorStudio.settings.prompt_modifier.length === 0
            ? _c("div", { attrs: { id: "nothing-selected" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm._f("trans")("Nothing Selected")) +
                    "\n            "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(
            this.creatorStudio.settings.prompt_modifier,
            function (option, index) {
              return _c(
                "div",
                { key: index },
                [_c("delete-prompt", { attrs: { prompt: option } })],
                1
              )
            }
          ),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "prompt-group-container" },
      _vm._l(_vm.prompts, function (prompt, index) {
        return _c("div", { key: index, staticClass: "prompt-heading" }, [
          _c("div", [_vm._v(_vm._s(_vm._f("trans")(prompt.name)))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "prompt-container" },
            _vm._l(prompt.options, function (option, index) {
              return _c(
                "div",
                { key: index },
                [_c("add-prompt", { attrs: { prompt: option } })],
                1
              )
            }),
            0
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }